// ----------------------------------------------------------------------------
// Block: Collapsible Content
// ----------------------------------------------------------------------------
// Independent accordion row for the Product info column. Each instance owns
// its own `.js-accordion` wrapper (no `data-collapse-all`) so opening one
// row does not close another. Hash-open is handled by the shared accordion
// helper.
// ----------------------------------------------------------------------------

import 'snippets/_containers/accordion/accordion';
import './_collapsible-content.scss';